import axios from "axios";
import { returnErrors } from "./error.action";
import { appConstants, config } from "../helpers/app-constants";
import { loaderDispatch } from "../helpers/app-constants";
import moment from "moment";

export const getHomePage = () => (dispatch) => {
    loaderDispatch(dispatch, true);
    axios
    //   .get(appConstants.BACKEND_URL + "getHomeSilder", config)
      .get('https://jsonplaceholder.typicode.com/todoss/1',config)
      .then((res) => {
        loaderDispatch(dispatch, false);
        dispatch({ type: appConstants.GET_HOME_DATA, payload: res.data });
      })
      .catch((err) => {
        loaderDispatch(dispatch, false);
        dispatch(returnErrors(err.message, err.message));
      });
  };

  export const getStockData = (symb,price) => (dispatch) => {
    let currentDate = moment().format('YYYY-MM-DD');
    loaderDispatch(dispatch, true);
    axios
      .get('https://api.polygon.io/v2/aggs/ticker/'+symb+'/range/1/day/2020-07-01/'+currentDate+'?apiKey=Oy9XWZU8lQCFJ9anII1iv4ak0krpIftE',config)
      .then((res) => {
        loaderDispatch(dispatch, false);
        dispatch({ type: appConstants.GET_STOCK_DATA, payload: res.data });
      })
      .catch((err) => {
        loaderDispatch(dispatch, false);
        dispatch({ type: appConstants.GET_STOCK_DATA, payload: err.response.data },returnErrors(err.response.data, err.response.data));
      });
  };
  
  export const getRealData = (symb,price) => (dispatch) => {
    let currentDate = moment().format('YYYY-MM-DD');
    let startdate = moment();
    startdate = startdate.subtract(4, "days");
    startdate = startdate.format("YYYY-MM-DD");
    loaderDispatch(dispatch, true);
    axios
    .get('https://api.polygon.io/v2/aggs/ticker/'+symb+'/range/15/minute/'+startdate+'/'+currentDate+'?apiKey=bvrwDpl_8C7yJOicLR8LIoxvj00SWpXm',config)
    .then((res) => {
        loaderDispatch(dispatch, false);
        dispatch({ type: appConstants.GET_REAL_DATA, payload: res.data });
      })
      .catch((err) => {
        loaderDispatch(dispatch, false);
        dispatch({ type: appConstants.GET_STOCK_DATA, payload: err.response.data },returnErrors(err.response.data, err.response.data));
      });
  };

  

export const saveSubscribeForm = (formdata) => (dispatch) => {
    loaderDispatch(dispatch, true, "saveSubscribeForm");
    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };
    const body = JSON.stringify(formdata);
    axios
      .post(appConstants.BACKEND_URL + "saveSubscribeForm", body, config)
      .then((res) => {
        dispatch({
          type: appConstants.SAVE_SUBSCRIBE_FORM,
          payload: res.data.data,
        });
        loaderDispatch(dispatch, false, "saveSubscribeForm");
      })
      .catch((err) => {
        loaderDispatch(dispatch, false, "saveSubscribeForm");
        dispatch(returnErrors(err.response, err.response));
      });
  };


